const isBet = (data) => {
  return typeof data === "object" && typeof data.bet_home_name === "string" && typeof data.market_event === "string" && typeof data.info_market_event === "string" && typeof data.commission === "number" && typeof data.chance === "number" && typeof data.stake === "number" && typeof data.block_chance === "boolean" && typeof data.block_stake === "boolean";
};
const isOperations = (data) => {
  return Array.isArray(data) && data.every(isBet);
};
const isTypeSurebet = (value) => {
  return typeof value === "string";
};
const isFormData = (data) => {
  return typeof data === "object" && typeof data.title === "string" && typeof data.sub_title === "string" && typeof data.part_link === "string" && new Date(data.time_expiration) instanceof Date;
};
export {
  isFormData,
  isOperations,
  isTypeSurebet
};